import { type ZodNull, type ZodString, z } from "zod";
import { localized } from "../../locales";
import { isValidIban } from "../../strings/is-valid-iban";

/**
 * An IBAN field that may stay empty: blank becomes null, anything else is stored compact and in
 * capitals and must carry the right check digits.
 */
export const ZodIbanNullable = z.preprocess(
	(val) => {
		if (val === undefined || val === null || val === "" || val === "null") return null;
		const compact = String(val).replace(/\s+/g, "").toUpperCase();
		return compact || null;
	},
	z
		.string()
		.refine(isValidIban, { message: localized("general.invalid_iban") })
		.nullable(),
) as unknown as ZodString | ZodNull;
